import { useState } from "react";
import { navigateToUserApp } from "../utils/navigateToUserApp";

/** Partner dashboard header — switch to user app (replaces credits pill). */
export default function CreditsBalance({ source = "partner_dashboard" }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await navigateToUserApp(source);
    } catch {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-mnf-pill border border-white/10 bg-mnf-dark-3 font-poppins text-xs font-semibold text-mnf-text-secondary hover:border-mnf-cyan/40 hover:text-mnf-cyan transition-all disabled:opacity-60 disabled:cursor-wait"
    >
      <span aria-hidden="true">👤</span>
      {loading ? "Opening…" : "Use as User"}
    </button>
  );
}
